import React from 'react';
import { RelativeTimeElement } from '@github/relative-time-element';
import { createComponent } from '../utils/custom-element.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RelativeTimeComponent = createComponent(RelativeTimeElement, 'relative-time');
const localeOptions = {
  month: 'short',
  day: 'numeric',
  year: 'numeric'
};
function RelativeTime({
  date,
  datetime,
  children,
  ...props
}) {
  var _date;
  if (datetime) date = new Date(datetime);
  return /*#__PURE__*/React.createElement(RelativeTimeComponent, _extends({}, props, {
    date: date
  }), children || ((_date = date) === null || _date === void 0 ? void 0 : _date.toLocaleDateString('en', localeOptions)) || '');
}
RelativeTime.displayName = "RelativeTime";

export { RelativeTime as default };
